import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ApiMap } from './components/ApiMarcas/ApiMap';
import { Barra1 } from './components/Navbar/Navbar';
import { Capacitaciones } from './components/pages/Capacitaciones';
import Cart from './components/Carrito/Cart'
import { ChangePassword } from './components/Profile/ChangePassword'
import Checkout from './components/Checkout/Checkout';
import { Contacto } from './components/pages/Contacto';
import { CookiesPolicy } from './components/helpers/CookiesPolicy'
import DetalleDeProducto from './components/DetalleDeProducto/DetalleDeProducto';
import { DetallesCompra } from "./components/Profile/DetallesCompra";
import { ErrorForm } from "./components/Formulario/ErrorForm";
import { Footer } from './components/Footer/Footer';
import { FormSuccess } from './components/Formulario/FormSuccess';
import { HomePage } from './components/HomePage/HomePage';
import NewLogin from './components/Login/NewLogin';
import { Newsletter } from './components/pages/Newsletter';
import { NotFound } from './components/helpers/NotFound'
import { NuestraEmpresa } from './components/pages/NuestraEmpresa';
import { Profile } from './components/Profile/Profile'
import RegistroUsuario from './components/pages/RegistroUsuario';
import { RmaItemFallado } from './components/pages/RmaItemFallado';
import { SelectorRma } from './components/pages/SelectorRma';
import { Success } from './components/Checkout/Success'
import { TrabajaConNosotros } from './components/pages/TrabajaConNosotros';
import { Iquote } from './components/iquote/Iquote'
import { ScrollButton } from './components/ScrollButton/ScrollButton';
import { PageForgotPass } from './components/ForgotPass/PageForgotPass';
import FormularioDenuncia from './components/pages/FormularioDenuncia';
import { Legajo } from './components/pages/Legajo';
import { ToastContainer } from 'react-toastify';
import RmaForm from './components/pages/RmaForm';
import GlobalContext from './components/Context/GlobalContext';
import CartContext from './components/Context/CartContext';
import AuthContext from './components/Context/AuthContext';
import MarcasContext from './components/Context/MarcasContext';
import { useEffect, useState } from 'react';
import { ApiCategorias } from './components/Categorias/ApiCategorias';
import ButtonWhatsapp from './components/ButtonWhatsapp/ButtonWhatsapp';
import OpenBox from './screens/Openbox/Openbox';
import Wireless from './components/pages/Tools/Wireless';
import IpTelephony from './components/pages/Tools/IpTelephony';
import Infraestructure from './components/pages/Tools/Infraestructure';
import Networking from './components/pages/Tools/Networking';
import DigitalSecurity from './components/pages/Tools/DigitalSecurity';
import LocalSecurity from './components/pages/Tools/LocalSecurity';
import SuccessPF from './screens/SuccessPF/SuccessPF';
import { PdfCatalogo } from './components/pages/PdfCatalogo';
import { PdfCatalogoEng } from './components/pages/PdfCatalogoEng';
import { SelectorCatalogo } from './components/pages/SelectorCatalogo';
import Header from './components/shared/Header/Header';
import ProductosFiltrados from './components/Buscador/ProductosFiltrados/ProductosFiltrados';
import { ResetPasswordAuto } from './components/ForgotResetPass/ResetPassAuto';
import PrivateRoute from './Routes/PrivateRoute'
import ProximosIngresos from './components/ProximosIngresos/ProximosIngresos'

function App() {
  const [countryMetadata, setCountryMetadata] = useState({});
  const country = process.env.REACT_APP_COUNTRY;

  useEffect(() => {
    const metadata = {
      UY: {
        title: 'Solution Box Uruguay - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Uruguay',
      },
      CL: {
        title: 'Solution Box Chile - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Chile',
      },
      DO: {
        title: 'Solution Box República Dominicana - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box República Dominicana',
      },
      PA: {
        title: 'Solution Box Panama - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Panama',
      },
      GT: {
        title: 'Solution Box Guatemala - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Guatemala',
      },
      SV: {
        title: 'Solution Box El Salvador - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box El Salvador',
      },
      HN: {
        title: 'Solution Box Honduras - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Honduras',
      },
      PY: {
        title: 'Solution Box Paraguay - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Paraguay',
      },
      CR: {
        title: 'Solution Box Costa Rica - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Costa Rica',
      },
      TT: {
        title: 'Solution Box Trinidad y Tobago - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Trinidad y Tobago',
      },
      PR: {
        title: 'Solution Box Puerto Rico - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Puerto Rico',
      },
      JM: {
        title: 'Solution Box Jamaica - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Jamaica',
      },
      USA: {
        title: 'Solution Box LLC - IT distribution company',
        description: 'Sitio web Solution Box USA',
      },
      ARG: {
        title: 'Solution Box SRL - Mayorista de informatica y telecomunicaciones',
        description: 'Sitio web Solution Box Argentina',
      },
    };

    // Actualizo la metadata
    setCountryMetadata(metadata[country] || {});
  }, [country]);

  useEffect(() => {
    // Ahora actualizo el html
    document.title = countryMetadata.title || 'Solution Box';

    // Actualizo otras etiquetas meta según la metadata del país
    updateMetaTags(countryMetadata);

  }, [countryMetadata]);

  const updateMetaTags = (metadata) => {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', metadata.description || 'Descripción predeterminada');
    }
  };

  /* BOTON WHATSAPP */
  const tieneBoton = country === "USA" || country === "SV" || country === "PA" || country === "HN" || country === "CR" || country === "GT" || country === "DO" || country === "ARG" ? true : false;

  

  return (
    <BrowserRouter>
      <AuthContext>
        <GlobalContext>
          {/* <AuthContext> */}
          <CartContext>
            <MarcasContext>
              <Header />
              <Barra1 />
              <ScrollButton />
              {tieneBoton && <ButtonWhatsapp />}
              <ToastContainer
                position="top-right"
                autoClose={3}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              <ToastContainer />
              <Routes>
                {/* Rutas públicas */}
                <Route path="/" element={<HomePage />} />
                <Route path='/newsletter' element={<Newsletter />} />
                <Route path='/trabajaconnosotros' element={<TrabajaConNosotros />} />
                <Route path='/contacto' element={<Contacto />} />
                <Route path='/catalogo' element={<PdfCatalogo />} />
                <Route path="/catalogueEng" element={<PdfCatalogoEng />} />
                <Route path="/selectorcatalogo" element={<SelectorCatalogo />} />
                <Route path="/productos/:query" element={<ProductosFiltrados />} />
                <Route path="/marcas/:id" element={<ApiMap />} />
                <Route path="/:sku" element={<DetalleDeProducto />} />
                <Route path="/openbox/:sku" element={<DetalleDeProducto />} />
                <Route path="/oferta/:sku" element={<DetalleDeProducto />} />
                <Route path="/forgotPassword" element={<PageForgotPass />} />
                <Route path="/olvido-reseteo-password" element={<ResetPasswordAuto/>}/>
                <Route path="/registroUsuario" element={<RegistroUsuario />}/>
                <Route path="/formularioDenuncia" element={<FormularioDenuncia />}/>
                <Route path="/Iquote" element={<Iquote />}/>
                <Route path='/categorias/:codigo' element={<ApiCategorias />} />
                <Route path='/cvcommit/fail' element={<ErrorForm />} />
                <Route path='/cvcommit/success/:id' element={<FormSuccess />} />
                <Route path='/rma' element={<SelectorRma />} />
                <Route path='/rma2' element={<RmaForm />} />
                <Route path='/rma3' element={<RmaItemFallado />} />
                <Route path='/cookies-policy' element={<CookiesPolicy />} />
                <Route path='/capacitaciones' element={<Capacitaciones />} />
                <Route path='/proximos-ingresos' element={<ProximosIngresos />} />
                <Route path='/nuestraempresa' element={<NuestraEmpresa />} />
                
                {/* Rutas privadas */}
                <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                <Route path="/profile/pedidos/:pedido" element={<PrivateRoute><DetallesCompra /></PrivateRoute>} />
                <Route path="/cart" element={<PrivateRoute><Cart /></PrivateRoute>} />
                <Route path="/checkout" element={<PrivateRoute><Checkout /></PrivateRoute>} />
                <Route path="/success" element={<PrivateRoute><Success /></PrivateRoute>} />
                <Route path="/cambiar-contrasenia" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
                {/* <Route path='/nuestraempresa' element={<PrivateRoute><NuestraEmpresa /></PrivateRoute>} /> */}
                
                {/* Rutas de login */}
                <Route path="/login" element={<NewLogin />} />
                <Route path="/newlogin" element={<NewLogin />} />
                
                {/* Otras rutas */}
                <Route path="*" element={<NotFound />} />
                <Route path="/info-impositiva" element={<Legajo />} />
                <Route path="/openbox" element={<OpenBox />} />
                <Route path="/wireless" element={<Wireless />} />
                <Route path="/iptelephony" element={<IpTelephony />} />
                <Route path="/infraestructure" element={<Infraestructure />} />
                <Route path="/networking" element={<Networking />} />
                <Route path="/localsecurity" element={<LocalSecurity />} />
                <Route path="/digitalsecurity" element={<DigitalSecurity />} />
                <Route path="/success/pedido/:idPedido/:extPedido" element={<SuccessPF />} />
                <Route path="/api/pedidos/orden/:idPedido/:extPedido" element={<SuccessPF />} />
              </Routes>

            </MarcasContext>
          </CartContext>
          {/* </AuthContext> */}
        </GlobalContext>
      </AuthContext>
      <Footer />
      <ScrollButton />
    </BrowserRouter>
  );
}
export default App;
